import styled from "styled-components";

const Widget = styled.div`
  opacity: 0;
`;

export default Widget;
